module.exports = __webpack_public_path__ + "img/abacus.4b8d8caf.svg";